/**
 * Notes on style.
 * For most chakra components they will take a colorScheme prop.  can pass any of the shades below into this with useTheme()
 * Or can use the primary theme colors that the shades were built off of with the primary object
 *
 * other themes were built off of this pallet https://coolors.co/00768c-a77e58-e0bad7-a2e3c4-50723c (may have to do walkthrough and reload page)
 *
 */
import {extendTheme, theme as base, theme} from '@chakra-ui/react';
import {mode} from '@chakra-ui/theme-tools';

const Theme = extendTheme({
  fonts: {
    // body: `'Source Serif Pro', serif`,
    heading: `'Source Serif Pro', serif`,
  },
  colors: {
    // primary: {
    //   lavender: '#E0BAD7',
    //   mint: '#A2E3C4',
    //   forest: '#50723C',
    //   brown: '#A77E58',
    //   graystone: '#00768C',
    // },
    graystone: {
      primary: '#00768C',
      secondary: '#52aeca',
      tertiary: '#57959d',
      mint: '#A2E3C4',
    },
    // All themes below are based off of the primary color scheme above, I put those themes into https://themera.vercel.app/ to get the 10 shades

    primary: {
      50: '#E5FBFF',
      100: '#B8F4FF',
      200: '#8AEDFF',
      300: '#5CE5FF',
      400: '#2EDEFF',
      500: '#00D7FF',
      600: '#00ACCC',
      700: '#008199',
      800: '#005666',
      900: '#002B33',
    },
    secondary: {
      50: '#EBF6F9',
      100: '#C8E5EE',
      200: '#A5D5E3',
      300: '#82C5D9',
      400: '#5FB4CE',
      500: '#3CA4C3',
      600: '#30839C',
      700: '#246275',
      800: '#18414E',
      900: '#0C2127',
    },
    tertiary: {
      50: '#EFF5F6',
      100: '#D1E3E6',
      200: '#B4D1D5',
      300: '#96BFC5',
      400: '#78AEB4',
      500: '#5B9CA4',
      600: '#497D83',
      700: '#375D62',
      800: '#243E42',
      900: '#121F21',
    },
    mint: {
      50: '#EBF9F3',
      100: '#C8EEDC',
      200: '#A5E4C6',
      300: '#82D9AF',
      400: '#5ECF99',
      500: '#3BC483',
      600: '#2F9D69',
      700: '#375D62',
      800: '#184E34',
      900: '#0C271A',
    },
  },
  // default site styles for backgrounds and headers
  styles: {
    global: props => ({
      body: {
        fontFamily: 'body',
        color: mode('primary.900', 'whiteAlpha.900')(props),
        bg: mode('white', 'gray.800')(props),
        lineHeight: 'base',
      },

      'h1, h2, h3, h4, h5, h6': {
        color: mode('graystone.primary', 'whiteAlpha.900')(props),
      },

      '*::placeholder': {
        color: mode('tertiary.400', 'whiteAlpha.400')(props),
      },
      '*, *::before, &::after': {
        borderColor: mode('tertiary.200', 'whiteAlpha.300')(props),
        wordWrap: 'break-word',
      },
    }),
  },
});

/**
 Default style:
 styles: {
    global: props => ({
      body: {
        fontFamily: 'body',
        color: mode('gray.800', 'whiteAlpha.900')(props),
        bg: mode('white', 'gray.800')(props),
        lineHeight: 'base',
      },
      '*::placeholder': {
        color: mode('gray.400', 'whiteAlpha.400')(props),
      },
      '*, *::before, &::after': {
        borderColor: mode('gray.200', 'whiteAlpha.300')(props),
        wordWrap: 'break-word',
      },
    }),
  },
 */
export default Theme;
